module.exports = __webpack_public_path__ + "34736292/img/link-icon.fa09ed66.svg";